import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import moment from 'moment';
import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { FormalizeCandidate } from 'src/app/core/models/formalizePayload';

@Component({
  selector: 'app-override-candidate-suspension',
  templateUrl: './override-candidate-suspension.component.html',
  styleUrls: ['./override-candidate-suspension.component.css']
})
export class OverrideCandidateSuspensionComponent implements OnInit {

  @Input() candidateId: any;
  @Input() candidateName: any;
  @Input() releaseDate: any;
  @Input() suspendedMonths: any;
  @Input() allowOverride: any;
  @Input() releasedJobDetails: any;
  @Input() recruiterDetails: any;
  @Input() type: any;
  @Output() saveCallback = new EventEmitter<void>();
  @Output() cancelCallback = new EventEmitter<void>();

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  previousJobDetails: any;
  displayHtmlText = '';
  loading = false;
  overridingFlag = false;
  formalizeActivityPayload: any;

  constructor(
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this._setHtmlDisplayText();
    this.setFormalizeActivityPayload();
  }

  private _setHtmlDisplayText() {
    if (this.type === 'release') {
      this.displayHtmlText = "Candidate '<span class='emerald'>" + this.candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + this.suspendedMonths + "</span>' month(s) of candidate's previous release. ";
      this.displayHtmlText = this.displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + moment(this.releaseDate).format('MMM DD, YYYY') + "</span>' from the role '<span class='emerald'>" + this.releasedJobDetails.role + "</span>' ";
      this.displayHtmlText = this.displayHtmlText + "with Requisition Number '<span class='emerald'>" + this.releasedJobDetails.requisitionNumber + "</span>'.";
    } else {
      this.displayHtmlText = "Candidate <span class='emerald'>'" + this.candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + this.suspendedMonths + "</span>' month(s) of leaving previous job. ";
      this.displayHtmlText = this.displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + moment(this.releaseDate).format('MMM DD, YYYY') + "</span>' from the role '<span class='emerald'>" + this.releasedJobDetails.role + "</span>' ";
      this.displayHtmlText = this.displayHtmlText + "with Requisition Number '<span class='emerald'>" + this.releasedJobDetails.requisitionNumber + "</span>'.";
    }
  }

  getPreviousJobDetails() {
    this.loading = true;
    this.jobService.getReleasedCandidateJobDetails(this.candidateId, (data) => {
      this.previousJobDetails = data[0];
      this.loading = false;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  overrideSuspension() {
    this.saveCallback.emit();
  }

  cancel() {
    this.cancelCallback.emit();
  }

  receiveFormalizedComment(event) {
    this.recruiterDetails.overrideNote = event;
  }

  onVoiceTranscript(transcript) {
    if (this.recruiterDetails.overrideNote) {
      this.recruiterDetails.overrideNote += ' ' + transcript;
    } else {
      this.recruiterDetails.overrideNote = transcript;
    }
  }

  setFormalizeActivityPayload() {
    this.formalizeActivityPayload = {
      candidate: new FormalizeCandidate(this.candidateId, this.candidateName, ''),
      requisition: null,
      jobMatch: null,
      company: null
    };
  }

}
